import React, { useState, useEffect } from 'react';
import { Select, Space, Typography } from 'antd';

const { Option } = Select;

export default function SubjectFilter({ nestedSubjects, setFilter }) {
  const [selectedMainSubject, setMainSubject] = useState(null);
  const [subSubjects, setSubSubjects] = useState(null);
  const [selectedSubSubject, setSubSubject] = useState(null);

  useEffect(() => {
    if (selectedMainSubject) {
      if (selectedMainSubject.children) {
        setSubSubjects(selectedMainSubject.children);
      } else {
        setSubSubjects(null);
        setSubSubject(null);
      }
    }
  }, [selectedMainSubject]);

  useEffect(() => {
    setFilter((prevFilter) => {
      const newFilter = { ...prevFilter };
      delete newFilter.$or;
      if (selectedSubSubject) {
        newFilter.$or = [
          { creditSubjectId: selectedSubSubject._id },
          { debitSubjectId: selectedSubSubject._id },
        ];
      } else if (!selectedSubSubject && selectedMainSubject) {
        if (selectedMainSubject.children) {
          newFilter.$or = [
            {
              creditSubjectId: {
                $in: selectedMainSubject.children.map((subject) => subject._id),
              },
            },
            {
              debitSubjectId: {
                $in: selectedMainSubject.children.map((subject) => subject._id),
              },
            },
          ];
        } else {
          newFilter.$or = [
            { creditSubjectId: selectedMainSubject._id },
            { debitSubjectId: selectedMainSubject._id },
          ];
        }
      }
      return newFilter;
    });
  }, [selectedMainSubject, selectedSubSubject, setFilter]);

  const handleMainSubjectChange = (value) => {
    setMainSubject(nestedSubjects.find((subject) => subject._id === value));
  };

  const handleSubSubjectChange = (value) => {
    setSubSubject(subSubjects.find((subject) => subject._id === value));
  };

  return (
    <Space>
      <div>
        <Typography.Text>借貸科目：</Typography.Text>
        <Select
          onChange={handleMainSubjectChange}
          style={{ width: '200px' }}
          allowClear
          placeholder="主科目"
        >
          {nestedSubjects.map((subject) => (
            <Option key={subject._id} value={subject._id}>
              {subject.subjectName}
            </Option>
          ))}
        </Select>
      </div>
      <Select
        onChange={handleSubSubjectChange}
        style={{ width: '200px' }}
        disabled={!subSubjects}
        allowClear
        placeholder="次科目"
      >
        {subSubjects &&
          subSubjects.map((subject) => (
            <Option key={subject._id} value={subject._id}>
              {subject.subjectName}
            </Option>
          ))}
      </Select>
    </Space>
  );
}
